<div class="adding-employee">
  <app-tab-list>
    <app-tab url="general" tabTitle="General"> </app-tab>
    <app-tab url="salary" tabTitle="Salary"> </app-tab>
  </app-tab-list>
</div>
